const LoadingBar = () => {
    return (
        <div className="loading_progress_bar" >
            <span className="loading_progress_bar_gauge run_gauge_animation" />
        </div>
    );
}
export default LoadingBar;